import { render, staticRenderFns } from "./MatchContentModal.vue?vue&type=template&id=5eacad3f&scoped=true"
import script from "./MatchContentModal.vue?vue&type=script&lang=js"
export * from "./MatchContentModal.vue?vue&type=script&lang=js"
import style0 from "./MatchContentModal.vue?vue&type=style&index=0&id=5eacad3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eacad3f",
  null
  
)

export default component.exports